"use strict";

function _typeof(obj) { "@babel/helpers - typeof"; if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.withLinks = exports.Leaf = exports.Element = exports.LinkButton = exports.MarkButton = exports.BlockButton = exports.Toolbar = void 0;

var _react = _interopRequireWildcard(require("react"));

var _slate = require("slate");

var _slateReact = require("slate-react");

var _validation = require("../../utils/validation");

var _antd = require("antd");

function _getRequireWildcardCache() { if (typeof WeakMap !== "function") return null; var cache = new WeakMap(); _getRequireWildcardCache = function _getRequireWildcardCache() { return cache; }; return cache; }

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") { return { default: obj }; } var cache = _getRequireWildcardCache(); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj.default = obj; if (cache) { cache.set(obj, newObj); } return newObj; }

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _slicedToArray(arr, i) { return _arrayWithHoles(arr) || _iterableToArrayLimit(arr, i) || _unsupportedIterableToArray(arr, i) || _nonIterableRest(); }

function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }

function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }

function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) { arr2[i] = arr[i]; } return arr2; }

function _iterableToArrayLimit(arr, i) { if (typeof Symbol === "undefined" || !(Symbol.iterator in Object(arr))) return; var _arr = []; var _n = true; var _d = false; var _e = undefined; try { for (var _i = arr[Symbol.iterator](), _s; !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i["return"] != null) _i["return"](); } finally { if (_d) throw _e; } } return _arr; }

function _arrayWithHoles(arr) { if (Array.isArray(arr)) return arr; }

var LIST_TYPES = ['numbered-list', 'bulleted-list'];

var toggleBlock = function toggleBlock(editor, format) {
  var isActive = isBlockActive(editor, format);
  var isList = LIST_TYPES.includes(format);

  _slate.Transforms.unwrapNodes(editor, {
    match: function match(n) {
      return LIST_TYPES.includes(n.type);
    },
    split: true
  });

  _slate.Transforms.setNodes(editor, {
    type: isActive ? 'paragraph' : isList ? 'list-item' : format
  });

  if (!isActive && isList) {
    var block = {
      type: format,
      children: []
    };

    _slate.Transforms.wrapNodes(editor, block);
  }
};

var toggleMark = function toggleMark(editor, format) {
  var isActive = isMarkActive(editor, format);

  if (isActive) {
    _slate.Editor.removeMark(editor, format);
  } else {
    _slate.Editor.addMark(editor, format, true);
  }
};

var isBlockActive = function isBlockActive(editor, format) {
  var _Editor$nodes = _slate.Editor.nodes(editor, {
    match: function match(n) {
      return n.type === format;
    }
  }),
      _Editor$nodes2 = _slicedToArray(_Editor$nodes, 1),
      match = _Editor$nodes2[0];

  return !!match;
};

var isMarkActive = function isMarkActive(editor, format) {
  var marks = _slate.Editor.marks(editor);

  return marks ? marks[format] === true : false;
};

var Toolbar = function Toolbar(_ref) {
  var children = _ref.children;
  return /*#__PURE__*/_react.default.createElement("div", {
    className: "CustomTextArea__toolbar"
  }, children);
};

exports.Toolbar = Toolbar;

var BlockButton = function BlockButton(_ref2) {
  var format = _ref2.format,
      icon = _ref2.icon;
  var editor = (0, _slateReact.useSlate)();
  return /*#__PURE__*/_react.default.createElement(_antd.Button, {
    type: isBlockActive(editor, format) ? 'primary' : 'ghost',
    icon: icon,
    onClick: function onClick(event) {
      event.preventDefault();
      toggleBlock(editor, format);
    }
  });
};

exports.BlockButton = BlockButton;

var MarkButton = function MarkButton(_ref3) {
  var format = _ref3.format,
      icon = _ref3.icon;
  var editor = (0, _slateReact.useSlate)();
  return /*#__PURE__*/_react.default.createElement(_antd.Button, {
    type: isMarkActive(editor, format) ? 'primary' : 'ghost',
    icon: icon,
    onClick: function onClick(event) {
      event.preventDefault();
      toggleMark(editor, format);
    }
  });
};

exports.MarkButton = MarkButton;

var LinkButtonForm = function LinkButtonForm(_ref4) {
  var icon = _ref4.icon,
      onSubmit = _ref4.onSubmit;

  var _useState = (0, _react.useState)(),
      _useState2 = _slicedToArray(_useState, 2),
      value = _useState2[0],
      setValue = _useState2[1];

  var handleOnChange = (0, _react.useCallback)(function (e) {
    e.persist();
    setValue(e.target.value);
  }, [setValue]);
  return /*#__PURE__*/_react.default.createElement(_antd.Row, {
    gutter: 10
  }, /*#__PURE__*/_react.default.createElement(_antd.Col, {
    span: 20
  }, /*#__PURE__*/_react.default.createElement(_antd.Input, {
    value: value,
    placeholder: "https://example.com",
    onChange: handleOnChange
  })), /*#__PURE__*/_react.default.createElement(_antd.Col, {
    span: 4
  }, /*#__PURE__*/_react.default.createElement(_antd.Button, {
    icon: icon,
    type: "primary",
    onClick: function onClick(e) {
      return onSubmit(value);
    }
  })));
};

var LinkButton = function LinkButton(_ref5) {
  var icon = _ref5.icon;

  var _useState3 = (0, _react.useState)(false),
      _useState4 = _slicedToArray(_useState3, 2),
      visible = _useState4[0],
      setVisible = _useState4[1];

  var _useState5 = (0, _react.useState)(),
      _useState6 = _slicedToArray(_useState5, 2),
      selection = _useState6[0],
      setSelection = _useState6[1];

  var editor = (0, _slateReact.useSlate)();
  var isActive = isLinkActive(editor);
  (0, _react.useEffect)(function () {
    if (visible && editor.selection) {
      setSelection(editor.selection);
    }
  }, [visible, editor]);
  var handleOnSubmit = (0, _react.useCallback)(function (url) {
    setVisible(false);

    if (!url) {
      return;
    }

    editor.apply({
      type: 'set_selection',
      properties: selection,
      newProperties: selection
    });
    insertLink(editor, url);
  }, [editor, selection]);
  return /*#__PURE__*/_react.default.createElement(_antd.Popover, {
    content: /*#__PURE__*/_react.default.createElement(LinkButtonForm, {
      icon: icon,
      onSubmit: handleOnSubmit
    }),
    trigger: "click",
    visible: visible,
    onVisibleChange: setVisible
  }, /*#__PURE__*/_react.default.createElement(_antd.Button, {
    type: isActive ? 'primary' : 'ghost',
    icon: icon,
    disabled: isActive
  }));
};

exports.LinkButton = LinkButton;

var Element = function Element(_ref6) {
  var attributes = _ref6.attributes,
      children = _ref6.children,
      element = _ref6.element;

  switch (element.type) {
    case 'block-quote':
      return /*#__PURE__*/_react.default.createElement("blockquote", attributes, children);

    case 'bulleted-list':
      return /*#__PURE__*/_react.default.createElement("ul", attributes, children);

    case 'heading-one':
      return /*#__PURE__*/_react.default.createElement("h1", attributes, children);

    case 'heading-two':
      return /*#__PURE__*/_react.default.createElement("h2", attributes, children);

    case 'list-item':
      return /*#__PURE__*/_react.default.createElement("li", attributes, children);

    case 'numbered-list':
      return /*#__PURE__*/_react.default.createElement("ol", attributes, children);

    case 'link':
      return /*#__PURE__*/_react.default.createElement("a", _extends({}, attributes, {
        href: element.url
      }), children);

    default:
      return /*#__PURE__*/_react.default.createElement("p", attributes, children);
  }
};

exports.Element = Element;

var Leaf = function Leaf(_ref7) {
  var attributes = _ref7.attributes,
      children = _ref7.children,
      leaf = _ref7.leaf;

  if (leaf.bold) {
    children = /*#__PURE__*/_react.default.createElement("strong", null, children);
  }

  if (leaf.code) {
    children = /*#__PURE__*/_react.default.createElement("code", null, children);
  }

  if (leaf.italic) {
    children = /*#__PURE__*/_react.default.createElement("em", null, children);
  }

  if (leaf.underline) {
    children = /*#__PURE__*/_react.default.createElement("u", null, children);
  }

  return /*#__PURE__*/_react.default.createElement("span", attributes, children);
};

exports.Leaf = Leaf;

var isLinkActive = function isLinkActive(editor) {
  var _Editor$nodes3 = _slate.Editor.nodes(editor, {
    match: function match(n) {
      return n.type === 'link';
    }
  }),
      _Editor$nodes4 = _slicedToArray(_Editor$nodes3, 1),
      link = _Editor$nodes4[0];

  return !!link;
};

var unwrapLink = function unwrapLink(editor) {
  _slate.Transforms.unwrapNodes(editor, {
    match: function match(n) {
      return n.type === 'link';
    }
  });
};

var wrapLink = function wrapLink(editor, url) {
  if (isLinkActive(editor)) {
    unwrapLink(editor);
  }

  var selection = editor.selection;

  var isCollapsed = selection && _slate.Range.isCollapsed(selection);

  var link = {
    type: 'link',
    url: url,
    children: isCollapsed ? [{
      text: url
    }] : []
  };

  if (isCollapsed) {
    _slate.Transforms.insertNodes(editor, link);
  } else {
    _slate.Transforms.wrapNodes(editor, link, {
      split: true
    });

    _slate.Transforms.collapse(editor, {
      edge: 'end'
    });
  }
};

var isUrl = function isUrl(text) {
  return _validation.URL_REGEXP.test(text);
};

var withLinks = function withLinks(editor) {
  var insertData = editor.insertData,
      insertText = editor.insertText,
      isInline = editor.isInline;

  editor.isInline = function (element) {
    return element.type === 'link' ? true : isInline(element);
  };

  editor.insertText = function (text) {
    if (text && isUrl(text)) {
      wrapLink(editor, text);
    } else {
      insertText(text);
    }
  };

  editor.insertData = function (data) {
    var text = data.getData('text/plain');

    if (text && isUrl(text)) {
      wrapLink(editor, text);
    } else {
      insertData(data);
    }
  };

  return editor;
};

exports.withLinks = withLinks;

var insertLink = function insertLink(editor, url) {
  if (editor.selection) {
    wrapLink(editor, url);
  }
};